import {
  PMCConfig,
  ProviderMatchProviderLocationV9,
  ProviderMatchProviderV9
} from '@kyruus/types';
import { ReactElement, SyntheticEvent } from 'react';
import {
  AvailabilityProps,
  ExtendedProvider,
  Log,
  SearchSummary
} from 'Src/types';
import ProviderList from './ProviderListV9';

export * from './constants';
export { default } from './ProviderListV9';

interface HeadsUpAvailabilityProps extends AvailabilityProps {
  location?: ProviderMatchProviderLocationV9;
  onTimeSlotsClick?: (
    event: SyntheticEvent,
    data: {
      providerId: number;
      date?: string;
      time?: string;
      href?: string;
      unformattedDate?: string;
      locationId?: string;
      patient_relationship?: string;
      [key: string]: unknown;
    }
  ) => void;
  onViewMoreClick?: (
    event: SyntheticEvent,
    data: {
      providerId?: number;
      viewMoreBookOnlineUrl?: string;
      [key: string]: unknown;
    }
  ) => void;
}

// temporary workaround until ProviderListV9 is refactored to TS
interface ProviderListV9Props {
  apptOptions: {
    location_id?: number;
  };
  config: PMCConfig;
  providers: ExtendedProvider[];
  customerCode: string;
  productName: string;
  searchSummary: SearchSummary;
  log: Log;
  profileSummaryParams: {
    from: string;
    location_id: string;
  };
  showProviderLocationsInProviderTile?: boolean;
  providerCallbackFunc: (provider: ProviderMatchProviderV9) => void;
  bookingCallbackFunc: (provider: ProviderMatchProviderV9) => void;
}

export const ProviderListV9 = ProviderList as any as (
  props: ProviderListV9Props & HeadsUpAvailabilityProps
) => ReactElement;
